import { render, staticRenderFns } from "./PageGroupUsers.vue?vue&type=template&id=81c10d08&scoped=true&"
import script from "./PageGroupUsers.vue?vue&type=script&lang=ts&"
export * from "./PageGroupUsers.vue?vue&type=script&lang=ts&"
import style0 from "./PageGroupUsers.vue?vue&type=style&index=0&id=81c10d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c10d08",
  null
  
)

export default component.exports